import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MappingService } from './mapping.service';

@Injectable()
export class AlertService implements OnDestroy {
  private subscriptions: Subscription = new Subscription();

  constructor(private mappingService: MappingService) {}

  getImageByType(type: string): string {
    let response = '';

    const { types } = this.mappingService.list.value.alert;
    const index = types.findIndex((t) => t.name === type);

    if (index >= 0) {
      response = types[index].imgUrl;
    } else {
      const indexTMP = types.findIndex((chr: any) => chr.name === 'AndOr');
      response = types[indexTMP].imgUrl;
    }

    return response;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
